import isElectron from 'is-electron'
import store from '@/store'

const children = [
  {
    title: 'Gerenciar Caixas',
    route: 'pdv-manage-pay-box',
    resource: 'PayBox',
    action: 'Read',
  },
  {
    title: 'Comandos do Caixas',
    route: 'pdv-manage-pay-box-commands',
    resource: 'PayBoxCommand',
    action: 'Read',
  },
  {
    title: 'Cartões de Administração',
    route: 'pdv-manage-admin-cards',
    resource: 'AdminCard',
    action: 'Read',
  },
  {
    title: 'Extrato do Caixa',
    route: 'pdv-pay-box-statements',
    resource: 'PayBox',
    action: 'Read',
  },
]

if (isElectron()) {
  children.push({
    title: 'Caixa',
    route: 'pdv-pay-box-open',
    resource: 'Auth',
    action: 'read',
    hidden: () => !!store?.getters?.['pages/pdv/payBoxConfiguration/isPdvInactive'],
  },
  {
    title: 'Configuração do PDV',
    route: 'pdv-pay-box-configuration',
    resource: 'PayBox',
    action: 'Setup',
  })
}

export default {
  title: 'PDV',
  icon: 'coin',
  iconPack: 'bootstrap',
  children,
}
